export default class TankModel {
    constructor(data) {
        this.id = data.id || null;
        this.customerId = data.customer_id || null;
        this.capacity = data.capacity || null;
        this.content = data.content || "";
        this.createdAt = data.created_at || "";
        this.updatedAt = data.updated_at || "";
        this.updated = data.updated || "";
        this.tag = data.tag || "";
        this.channelId = data.channel_id || "";
        this.unit = data.unit || "";
        this.currentVolume = data.current_volume || 0;
        this.isActive = data.is_active || 0;
        this.rechargeLevel = data.recharge_level || 0;
        this.criticalLevel = data.critical_level || 0;
        this.customerName = data.customer_name || "";
        this.hasAlert = data.has_alert || false;
        this.level = data.level || 0;
    }

    static fromJSON(json) {
        return new TankModel(json);
    }
}
